<template>
    <div class="base-realname" :class="{'realname-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">实名认证</div>
            </div>
            <div class="content-auto">
                <div class="tips">
                    根据国家相关规定，游戏用户需进行实名认证，具体详情请查看
                    <span @click="$router.push('/base-wallow')">《防沉迷政策》</span>
                </div>
                <input class="val" type="text" placeholder="请输入真实姓名" v-model="name" />
                <input class="val" type="text" placeholder="请输入身份证号码" v-model="idCard" />
                <transition name="component-fade" mode="out-in">
                    <TheTips :msg='msg' v-if="msg" />
                </transition>
            </div>
        </div>
        <div class="btn">
            <div class="item" @click="cancel">暂不认证</div>
            <div class="item" @click="submit">提交认证</div>
        </div>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        name: 'BaseRealname',
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                name: '',
                idCard: null,
                loginData: {},
                userData: {}
            }
        },
        methods: {
            cancel () {
                this.$router.push('/base-visitor?id=' + this.$route.query.app_uid)
            },
            // 提交实名验证
            submit () {
                // 身份证号码正则表达式  15位或者18位，15位为全数字，18位前17位为数字，最后一位可能是数字或字符X
                let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                if (!this.name.replace(/\s*/g, "")) {
                    this.msg = '真实姓名不能为空'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                if(!reg.test(this.idCard)) {
                    this.msg = '身份证号码不合法'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    return false
                }
                let options = {
                    uid: this.userData.data.uid,
                    real_name: this.name,
                    id_card: this.idCard,
                    appid: this.loginData.appid,
                }
                options.sign = this.util.getSign(options, this.loginData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=id_auth', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.msg = '提交成功'
                        setTimeout(() => {
                            this.msg = null
                            this.toGame(this.$route.query.app_uid)
                        }, 1000)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            // 进入游戏
            toGame (id) {
                let options = {
                    uid: this.userData.data.uid,
                    app_uid: id,
                    token: this.userData.data.token,
                    appid: this.loginData.appid, //渠道ID
                    system: this.config.system, //系统
                    machine_code: this.loginData.machine_code, //设备号
                };
                options.sign = this.util.getSign(options, this.loginData.appkey);
                options.real_name_verify = 0;   // 是否需要实名验证，1为需要，0为不需要
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=check_switch_user', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.onLoginSucceed(res.data.data.app_uid, res.data.data.token, res.data.data.uid)
                    } else {
                        this.msg = res.data.msg
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                        this.onLoginError(res.data.msg)
                    }
                }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
            },
            // 进入游戏成功回调
            onLoginSucceed (account, token, uid) {
                let that = this
                if (that.config.system == 2) {
                    window.webkit.messageHandlers.wz_callOC.postMessage({
                        method: 'onLoginSucceed',
                        param: {
                            account: account,
                            token: token,
                            uid: uid,
                            status: that.userData.data.is_auth
                        }
                    })
                } else {
                    window.Android.onLoginSucceed(account, token, uid, that.userData.data.is_auth)
                }
            },
            // 进入游戏失败回调
            onLoginError (error) {
                if (this.config.system == 2) {
                    window.webkit.messageHandlers.wz_callOC.postMessage({
                        method: 'onLoginFailed'
                    })
                } else {
                    window.Android.onLoginFailed(error)
                }
            }
        },
        created () {
            this.loginData = JSON.parse(sessionStorage.getItem('loginData'))
            this.userData =JSON.parse(sessionStorage.getItem('userData'))
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-realname {
        width: 864px;
        min-height: 888px;
        overflow: hidden;
        padding-bottom: 60px;
        border-radius: 18px;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s;
        .content {
            flex: 1;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
            }
            .content-auto {
                padding: 0 60px;
                overflow: hidden;
                .tips {
                    font-size: 39px;
                    margin: 60px 0 60px;
                }
                .tips span {
                    color: $color;
                }
                .val {
                    width: 100%;
                    height: 120px;
                    color: #fff;
                    font-size: 39px;
                    border-radius: 18px;
                    border: 0;
                    background: rgba(255, 255, 255, 0.2);
                    padding: 0 45px;
                    margin-bottom: 30px;
                    outline: none;
                }
                input::-webkit-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-moz-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-ms-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
                input::-o-input-placeholder{
                    color:rgba(255, 255, 255, 0.5);
                }
            }
        }
        .btn {
            height: 120px;
            margin: 55px 60px 0 60px;
            display: flex;
            justify-content: space-between;
            .item {
                width: 345px;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border-radius: 18px;
                background: $color;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .item:first-child {
                background: rgba($color, 0.5);
            }
        }
    }
    // 竖屏css
    .realname-sp {
        width: 1570px;
        min-height: 1614px;
        padding-bottom: 90px;
        border-radius: 32px;
        .content {
            .header {
                height: 240px;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
            }
            .content-auto {
                padding: 0 90px;
                .tips {
                    font-size: 70px;
                    margin: 90px 0 90px;
                }
                .val {
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                    padding: 0 81px;
                    margin-bottom: 54px;
                }
            }
        }
        .btn {
            height: 200px;
            margin: 100px 90px 0 90px;
            .item {
                width: 627px;
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
            }
        }
    }
</style>